const en = {
  migration_title: 'Just For You Offer',
  migration_label_days: ' Days ',
  migration_label_from_offer_end: 'till the end of offers\'s eligibility',
  migration_view_details: 'View More',
  migration_details_title: 'Usage details',
  migration_info: 'Control, flexibility, security',

  migration_step1_title: 'Offer',
  migration_step2_title: 'Terms',
  migration_step3_title: 'Verification',
  migration_step4_title: 'Summary',

  migration_close_modal: 'Go back',
  migration_try_again: 'Try again',
  migration_call_me_back: 'Call me back',
  migration_reserve: 'Reserve',

  migration_offer_section_title: '',
  migration_offer_type: 'Recommended for you',
  migration_contract_section_title: 'Select contract length',
  migration_contract_confirm: 'Continue',

  migration_terms_section_title: 'Terms and conditions',
  migration_terms_collapse_title: 'Detailed information',
  migration_terms_collapse_subtitle: 'See all terms and conditions',
  migration_terms_agree: 'I agree',
  migration_terms_agree_all: 'I agree to all terms and conditions',
  migration_terms_accept_info: 'By tapping ‘Accept’, you accept our terms and conditions. See terms and conditions above.',
  migration_terms_accept: 'Accept',
  migration_terms_decline: 'Decline',

  migration_account_section_title: 'Account info',
  migration_account_section_info: 'Please put your personal number from your ID card.\nWe keep your personal data safe and use them to assure that you are the user of this number.',
  migration_id_placeholder: 'Identification number',
  migration_id_helper_title: 'Find ID number',
  migration_id_helper_info: ' Personal number is the 10 digits number of your ID as shown in this photo',
  migration_email_placeholder: 'Email address',
  migration_vat_number_placeholder: 'VAT Number',
  migration_vat_number_helper_title: 'VAT Number',
  migration_vat_number_helper_info: 'VAT Number is the 10 character number of your business registration document as shown in this photo',
  migration_individual_account: 'Individual',
  migration_business_account: 'Business',
  migration_account_verify_details: 'Verify details',

  migration_pin_section_title: 'OTP Verification',
  migration_pin_section_info: 'OTP(One Time Pin)',
  migration_pin_sent_to: 'We have sent the verification number to %1$s',
  migration_enter_pin: 'Please enter the %1$s digit code',
  migration_resend_pin: 'Re-send code',
  migration_confirm_pin: 'Confirm',

  migration_verification_section_title: 'Verification details',
  migration_verification_section_info: 'Please complete the below fields to verify your account, by providing the 3 latest paid amount for you number and the 3 most frequent numbers called.',
  migration_last_recharges_placeholder: 'Amount of the latest 3paid amounts.',
  migration_last_recharges_currency: '%1$s leke',
  migration_frequently_contacted_placeholder: 'Top 3 most frequent numbers called',

  migration_personal_section_title: 'Personal details',
  migration_personal_section_info: 'Please input your ID number and your email address to verify your data.',
  migration_name_placeholder: 'Name',
  migration_surname_placeholder: 'Surname',
  migration_address_placeholder: 'Address',
  migration_contact_number_placeholder: 'Contact number',

  migration_id_section_title: 'Add your ID',
  migration_id_section_info: 'We need to take details of a valid form of identification so we can verify your identity. We need a photo of your ID to be able to do the validation.',
  migration_scan_id_info: 'You can add your details by scanning your ID with your camera to verify the details',
  migration_scanned_image_title: '',
  migration_remove_photo: 'Remove photo',
  migration_scan_id_title: 'Scan your ID card',
  migration_scan_id_instructions: 'Place your id inside the frame',
  migration_scaning_id: 'Scanning...',

  migration_camera_permission_title: 'Permission to use camera',
  migration_camera_permission_message: 'We need your permission to use your camera',
  migration_camera_permission_positive: 'Ok',
  migration_camera_permission_negative: 'Cancel',

  migration_scan_id: 'Scan your ID',

  migration_verify_details: 'Verify details',

  migration_selected_section_title: 'My selection',
  migration_selected_section_info: '',

  migration_summary_section_title: 'Total cost',
  migration_summary_section_info: 'Your fixed tariff plan fee',
  migration_start_date: 'Start date',
  migration_start_today: 'Today %1$s',
  migration_contract_duration: 'Duration',

  migration_confirm: 'Confirm',

  migration_something_went_wrong: 'Something went wrong',
  migration_error_wrong_id: 'Error, id code wrong',
  migration_data_not_confirmed: 'Data not confirmed',
  migration_back_to_dashboard: 'Go back to dashboard',
  migration_back_to_summary: 'Back to summary',
  migration_existing_order_processing: 'Your offer is being validated',
  migration_oops_problem: 'Oops, there’s a problem!',
  migration_success: 'Congratulations',
  migration_extra_benefits: 'Extra benefits',
  migration_order_processing: 'Processing order',

  migration_congratulation_message: 'In just a few minutes you will receive a confirmation SMS, to enjoy uninterrupted communication.\nDon’t forget to visit one of the shops to complete the steps.',
  migration_existing_order_message: 'In just a few minutes you will receive a confirmation SMS, to enjoy uninterrupted communication.\nDon’t forget to visit one of the shops to complete the steps.',

  migration_wrong_id_format: 'Click info to see the correct id format.',
  migration_wrong_email_format: 'Type your email address in the format (email@exampe.com).',
  migration_wrong_vat_number_format: 'VAT Number has 10 characters',
  migration_wrong_name_format: ' Please write your name correctly.',
  migration_wrong_surname_format: ' Please write your surname correctly.',
  migration_wrong_address_format: ' Please write your address correctly. ',
  migration_wrong_contact_format: ' Please write numbers correctly.',
  migration_wrong_last_recharge_format: ' Please write recharge correctly.',
  migration_wrong_frequently_contacted_format: ' Please write numbers correctly.',
  migration_processing_action: 'Processing...',

  migration_id_error_title: 'Oppss...',
  migration_id_error_desc: 'Your ID number does not match with your registration information.\nReserve your offer or retry with to enter the data once again.',
  migration_reservation_success_title: 'Reserved just for you...',
  migration_reservation_success_desc: 'The offer is yours for 48 hours in any Vodafone Shop. Hurry up to get it before it changes.',

  migration_details_link: 'https://api-web-ci-vfal.vodafone.com/file/inAppMigration/ViewDetails/ViewDetails_EN.html',

  migration_save_button: 'Save',
}

export default en
